var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Defaults, Watch, PropertyConverters, ViewChild, Utils, CustomElementUtils, PacemEventTarget, Net } from '@pacem/pacem-core';
import { EXPRESSION_METADATA_TYPE } from '../../scaffolding/types';
import { buildWidgetMetadata, gridifyMetadata } from '../types';
import { PacemBearerWidgetElement, ACCESS_TOKEN_METADATA } from './types';
//namespace Pacem.Components.Cms {
const FETCH_PARAMETER_METADATA = {
    props: [
        { prop: 'name', type: 'string', isReadOnly: true, display: { name: 'Name', cssClass: ['cols-md-4', 'cols-lg-3', 'cols-hd-2'] } },
        { prop: 'value', type: EXPRESSION_METADATA_TYPE, display: { name: 'Value', cssClass: ['cols-md-8', 'cols-lg-9', 'cols-hd-10'] } }
    ]
};
const FETCH_METADATA = {
    display: {
        icon: 'wifi', name: 'Api Fetcher', description: 'Fetching widget that retrieves data from a REST endpoint.'
    }, props: [
        {
            prop: 'manifest', type: EXPRESSION_METADATA_TYPE, isComplexType: true, display: {
                name: 'Api Manifest'
            }, extra: {
                selector: P + '-widget-apimanifest'
            }, validators: [{ type: 'required', errorMessage: 'Api Manifest is a required field.' }]
        },
        {
            prop: 'endpoint', type: 'object', isComplexType: true, display: {
                name: 'Endpoint', ui: 'oneToMany'
            }, validators: [{ type: 'required', errorMessage: 'Api Manifest is a required field.' }],
            extra: {
                source: (manifest) => manifest.endpoints.map(e => Utils.extend(e, { 'fullPath': `[${e.method.toUpperCase()}] ${e.path}` })).sort(),
                textProperty: 'fullPath', valueProperty: 'fullPath',
                dependsOn: [{ prop: 'manifest', hide: true }]
            }
        },
        {
            prop: 'parameters', type: 'array', display: {
                name: 'Parameters'
            },
            props: gridifyMetadata(FETCH_PARAMETER_METADATA),
            extra: {
                lockItems: true,
                dependsOn: [{ prop: 'endpoint', hide: true }]
            }
        },
        ACCESS_TOKEN_METADATA
    ]
};
const PARAMETER_TAGNAME = P + '-widget-fetch-parameter';
let PacemWidgetFetchParameterElement = class PacemWidgetFetchParameterElement extends PacemEventTarget {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val.first);
        if (name === 'value' && !Utils.isNull(this._fetcher)) {
            this._fetcher.fetch();
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const fetcher = this._fetcher = CustomElementUtils.findAncestorOfType(this, PacemWidgetFetchElement);
        if (!Utils.isNull(this._fetcher) && !Utils.isNull(this.value)) {
            this._fetcher.fetch();
        }
    }
};
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.Boolean })
], PacemWidgetFetchParameterElement.prototype, "required", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemWidgetFetchParameterElement.prototype, "name", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.String })
], PacemWidgetFetchParameterElement.prototype, "value", void 0);
PacemWidgetFetchParameterElement = __decorate([
    CustomElement({ tagName: PARAMETER_TAGNAME })
], PacemWidgetFetchParameterElement);
export { PacemWidgetFetchParameterElement };
let PacemWidgetFetchElement = class PacemWidgetFetchElement extends PacemBearerWidgetElement {
    constructor() {
        super(buildWidgetMetadata(FETCH_METADATA));
        this._onerror = (e) => {
            this.failure = !(this.success = false);
        };
        this._onsuccess = (e) => {
            this.failure = !(this.success = true);
        };
        this._onresult = (e) => {
            this.result = e.detail;
        };
    }
    get _parameters() {
        return Array.from(this._itemsElement.children).filter(e => e.localName === PARAMETER_TAGNAME);
    }
    fetch() {
        const fetcher = this._fetcher, parameters = this._parameters || [], endpoint = this.endpoint;
        if (!Utils.isNull(endpoint)) {
            for (let param of endpoint.parameters) {
                if (param.required && Utils.isNull(parameters.find(p => p.name === param.name))) {
                    // parameters not yet aligned with the ref endpoint:
                    // not all the required parameters are attached => exit
                    return;
                }
            }
        }
        // build-up fetch params
        const params = {};
        for (let parameter of parameters) {
            if (!Utils.isNullOrEmpty(parameter.value)) {
                params[parameter.name] = parameter.value;
            }
            else if (parameter.required) {
                // found an empty (required) parameter => exit
                return;
            }
        }
        fetcher.url = this.url;
        fetcher.method = this.method;
        fetcher.credentials = this.fetchCredentials;
        fetcher.headers = this.fetchHeaders;
        fetcher.parameters = params;
        return fetcher.fetch();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.fetch();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'endpoint' && !Utils.isNullOrEmpty(val)) {
            this._mergeEndpoint(val);
        }
        else
            switch (name) {
                case 'parameters':
                case 'fetchHeaders':
                case 'fetchCredentials':
                case 'url':
                case 'method':
                    this.fetch();
                    break;
            }
    }
    _mergeEndpoint(endpoint = this.endpoint) {
        this.url = this.manifest.baseUrl + endpoint.path;
        this.method = endpoint.method;
        this.fields = endpoint.response.fields;
        const itemsElement = this._itemsElement, parameters = this._parameters;
        // remove exceeding
        for (let j = parameters.length - 1; j >= 0; j--) {
            let item = parameters[j];
            let matching = endpoint.parameters.find(p => p.name === item.name);
            if (Utils.isNull(matching)) {
                item.remove();
            }
        }
        // add missing
        for (let param of endpoint.parameters) {
            let existing = parameters.find(p => p.name === param.name);
            if (Utils.isNull(existing)) {
                let item = existing = document.createElement(PARAMETER_TAGNAME);
                item.name = param.name;
                itemsElement.appendChild(item);
            }
            existing.required = param.required;
        }
        // for editing sake
        this.parameters = parameters;
    }
};
__decorate([
    Watch({ reflectBack: true, emit: true /* < due to metadata 'dependsOn' */, converter: PropertyConverters.Json })
], PacemWidgetFetchElement.prototype, "manifest", void 0);
__decorate([
    Watch({ reflectBack: true, emit: true /* < due to metadata 'dependsOn' */, converter: PropertyConverters.Json })
], PacemWidgetFetchElement.prototype, "endpoint", void 0);
__decorate([
    Watch({ reflectBack: true, emit: false, converter: PropertyConverters.String })
], PacemWidgetFetchElement.prototype, "url", void 0);
__decorate([
    Watch({ reflectBack: true, emit: false, converter: PropertyConverters.String })
], PacemWidgetFetchElement.prototype, "method", void 0);
__decorate([
    Watch({ reflectBack: true, emit: false, converter: PropertyConverters.Json })
], PacemWidgetFetchElement.prototype, "fields", void 0);
__decorate([
    Watch( /* just for editing sake */)
], PacemWidgetFetchElement.prototype, "parameters", void 0);
__decorate([
    Watch( /* can only be databound or assigned at runtime */)
], PacemWidgetFetchElement.prototype, "result", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemWidgetFetchElement.prototype, "fetching", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemWidgetFetchElement.prototype, "success", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemWidgetFetchElement.prototype, "failure", void 0);
__decorate([
    ViewChild(P + '-fetch')
], PacemWidgetFetchElement.prototype, "_fetcher", void 0);
__decorate([
    ViewChild('div[hidden]')
], PacemWidgetFetchElement.prototype, "_itemsElement", void 0);
PacemWidgetFetchElement = __decorate([
    CustomElement({
        tagName: P + '-widget-fetch', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-fetch autofetch="false" fetching="{{ :host.fetching, twoway }}" debounce="100"
on-${Net.FetchResultEventName}=":host._onresult($event)" on-${Net.FetchErrorEventName}=":host._onerror($event)" on-${Net.FetchSuccessEventName}=":host._onsuccess($event)"></${P}-fetch><div hidden><${P}-content></${P}-content></div>`
    })
], PacemWidgetFetchElement);
export { PacemWidgetFetchElement };
